// removed by extract-text-webpack-plugin
module.exports = {"container":"styles-container--gJ116","list":"styles-list--2yziz","detail":"styles-detail--1xjSU","listFilter":"styles-listFilter--2ThDC","listItems":"styles-listItems--3KRoi","active":"styles-active--3JIMi","clientListItem":"styles-clientListItem--ZPcqy","primaryTravelerName":"styles-primaryTravelerName--r-ozn"};


//////////////////
// WEBPACK FOOTER
// /src/components/Clients/styles.scss
// module id = DsNi
// module chunks = 1